import "./GoogleReviews.css";

const reviews = [
  {
    name: "Rahul Sharma",
    rating: 5,
    text: "Excellent service! Bike condition was perfect and pickup was smooth.",
  },
  {
    name: "Sneha Patel",
    rating: 5,
    text: "Very affordable and transparent pricing. Highly recommended!",
  },
  {
    name: "Amit Verma",
    rating: 4,
    text: "Good experience overall. Support team was very helpful.",
  },
];

function GoogleReviews() {
  return (
    <section className="reviews-section">
      <h2>⭐ What Our Riders Say</h2>

      <div className="google-badge">
        <span className="rating">4.8 ★</span>
        <span className="source">Google Reviews</span>
      </div>

      <div className="reviews-grid">
        {reviews.map((r, index) => (
          <div key={index} className="review-card">
            <div className="review-stars">
              {"★".repeat(r.rating)}
              {"☆".repeat(5 - r.rating)}
            </div>

            <p className="review-text">"{r.text}"</p>

            <p className="review-name">— {r.name}</p>
          </div>
        ))}
      </div>

      <a
        href="https://www.google.com/maps/place/Bro's+Bike+Rental+Gokarna/@14.5479434,74.315092,891m/data=!3m1!1e3!4m8!3m7!1s0x3bbe83072c1ab005:0x5ef1c3d62bed983!8m2!3d14.5479434!4d74.3176723!9m1!1b1!16s%2Fg%2F11y57hwf91?entry=ttu&g_ep=EgoyMDI2MDkyMS4wIKXMDSoASAFQAw%3D%3D"
        target="_blank"
        rel="noreferrer"
        className="google-link"
      >
        View all reviews on Google
      </a>
    </section>
  );
}

export default GoogleReviews;
